<button class="square-btn btn-clear">
  <hf-named-icon [icon]="icon"></hf-named-icon>
</button>

<div *ngIf="label" class="label">
  {{ label }}
</div>
